import type { StylePropertiesTypes } from '@wix/document-services-types'
import type { PositionalJustifyContent } from '@wix/thunderbolt-becky-root'

/** Internal Converters */
const positionalJustifyContentConverter = (prop: PositionalJustifyContent) => {
	return prop.value
}

/** External Mapper */
export const justifyContentConverterMap = {
	PositionalJustification: positionalJustifyContentConverter,
	UnsafePositionalJustification: positionalJustifyContentConverter,
	SafePositionalJustification: positionalJustifyContentConverter,
} as Record<string, (prop: StylePropertiesTypes.JustifyContent) => string>
